<template>
  <div
    ref="elementRef"
    :class="{ block__content: onHp }"
  >
    <template v-if="isDataLoaded && hasAnyPosts">
      <Heading
        class="heading--semibold mt-0 mb-16"
        kind="h2"
        type="h5"
        v-t="$t('dashboard.blog.title')"
        v-if="!onHp"
      />
      <div :class="wrapperClass">
        <Card
          :date="post.date | formatDate(dateFormats.dateFns)"
          :image-url="post.smallImage"
          :key="post.uid"
          :perex="post.perex"
          :title="post.title"
          :url="post.path"
          v-for="post in collection"
        />
      </div>

      <hr
        class="my-32 delimiter"
        v-if="withDelimiter"
      >
    </template>
  </div>
</template>

<script>
import { POSTS_QUERY } from '~/queries';
import { mapGetters } from 'vuex';

export default {
  components: {
    Card: () => import('~/components/Card.vue'),
  },
  props: {
    postsCount: {
      default: 6,
      type: Number,
    },
    onHp: {
      default: false,
      type: Boolean,
    },
    withDelimiter: Boolean,
  },
  apollo: {
    posts: {
      query: POSTS_QUERY,
      variables() {
        return {
          limit: this.postsCount,
          showOnHomepage: true,
        };
      },
      result() {
        this.isDataLoaded = true;
      },
      skip() {
        return this.skipQuery;
      },
    },
  },
  data: () => ({
    isDataLoaded: false,
    isInViewport: false,
    skipQuery: true,
  }),
  computed: {
    ...mapGetters('env', ['dateFormats']),
    collection() {
      return this.posts.collection;
    },
    hasAnyPosts() {
      return this.collection.length > 0;
    },
    wrapperClass() {
      if (this.postsCount === 6 || this.postsCount === 3) {
        return 'content-card__wrapper content-card__wrapper--large-columns';
      }

      return 'content-card__wrapper';
    },
  },
  methods: {
    onIntersection(entries) {
      const [entry] = entries;
      if (entry.isIntersecting && !this.isDataLoaded) {
        this.fetchPosts();
      }
    },
    fetchPosts() {
      this.skipQuery = false;
      this.$apollo.queries.posts.refetch();
    },
  },
  mounted() {
    const offsets = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };
    const observer = new IntersectionObserver(this.onIntersection, offsets);

    observer.observe(this.$refs.elementRef);
  },
};
</script>

<style lang="scss" scoped>
.block__content {
  margin-bottom: 100px;

  @media only screen and (max-width: $--lg - 1px) {
    margin-bottom: 40px;
  }

  @media only screen and (max-width: $--md - 1px) {
    margin-bottom: 15px;
  }
}

.delimiter {
  border-top-color: $--border-color-base;
}
</style>
